import { service } from '../../../../helpers/http'

export const ActionFindUserTeachers = ({ dispatch }, payload) => {

    return service({
        module: 'timeSheet',
        action: 'findUserTeachers',
        payload: payload
    })

}

export const ActionCreateUserTeacher = ({ dispatch }, payload) => {

    return service({
        module: 'timeSheet',
        action: 'createUserTeacher',
        payload: payload
    })

}

export const ActionUpdateUserTeacher = ({ dispatch }, payload) => {

    return service({
        module: 'timeSheet',
        action: 'updateUserTeacher',
        payload: payload
    })
}

export const ActionDeleteUserTeacher = ({ dispatch }, payload) => {

    return service({
        module: 'timeSheet',
        action: 'deleteUserTeacher',
        payload: payload
    })

}
